import { FORWARDED_PARAM_KEYS } from 'components/shared/CustomLink';

/** Full page URL for utm_source, e.g. `www.ultrahuman.com/in/performance-lab/recovery/`. */
export function getPageUrlUtmSource(fallback = 'performance-lab'): string {
  if (typeof window === 'undefined') return fallback;
  return `${window.location.hostname}${window.location.pathname}`;
}

/**
 * Builds the `tracking` object for `@typeform/embed` Widget.
 * For each key in {@link FORWARDED_PARAM_KEYS}, the current page URL wins when set;
 * then `defaults` fill any keys still missing (URL always overrides defaults for the same key).
 */
export function buildTypeformTrackingFromUrl(
  defaults: Record<string, string>,
): Record<string, string> {
  if (typeof window === 'undefined') {
    return { ...defaults };
  }

  const params = new URLSearchParams(window.location.search ?? '');
  const forwarded = new Set(FORWARDED_PARAM_KEYS);
  const keys = new Set<string>([
    ...FORWARDED_PARAM_KEYS,
    ...Object.keys(defaults),
  ]);
  const out: Record<string, string> = {};

  for (const key of keys) {
    const fromUrl = forwarded.has(key) ? params.get(key) ?? '' : '';
    const value = fromUrl || defaults[key] || '';
    if (value) {
      out[key] = value;
    }
  }

  return out;
}
